import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FeatureCollection, MultiPolygon, Polygon } from "@turf/helpers";
import { filter, firstValueFrom, Subscription } from "rxjs";
import { EnumGeofenceZones } from "src/app/features/shared/helpers/enums/EnumGeofenceZones";
import { MapHelperService } from "src/services/map-helper.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { TurfHelperService } from "src/services/turf-helper.service";
import { EnumFeaturesActionsDestinations } from "src/app/features/shared/helpers/enums/EnumFeaturesActionsDestinations";
import { PanelAddGeofencesService } from "../../../../services/Panel-Add-Geofences.service";
import { PolygonSelectorComponent } from "src/app/features/map-features/ui/organisms/polygon-selector/components/polygon-selector/polygon-selector.component";
import { PolygonSelectionEvent } from "src/app/features/map-features/ui/organisms/polygon-selector/models/polygon-selector.models";

@Component({
  selector: "zone-selector",
  templateUrl: "./zone-selector.component.html",
  styleUrls: ["./zone-selector.component.css"],
})
export class ZoneSelectorComponent {
  @ViewChild('polygonSelectorGeofence') polygonSelector: PolygonSelectorComponent;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  fullScreen: boolean = false;

  selectedZoneId: number = 0;
  selectedStateId: string = "09";
  canSelectMunicipios: boolean = false;
  startedMunicipiosSelection: boolean = false;
  isReturningToState: boolean = false;

  selectedFeaturesStateBackUp: FeatureCollection<Polygon | MultiPolygon> = { type: "FeatureCollection", features: [] };

  private isDestroyed: boolean = false;

  zones: { id: number; name: string }[] = [
    { id: EnumGeofenceZones.Estados, name: "Estados" },
    // { id: EnumGeofenceZones.Municipios, name: "Municipios" },
    // { id: EnumGeofenceZones.Regiones, name: "Regiones" },
  ];

  states: { id: string; name: string }[] = [
    { id: "09", name: "Ciudad de México" },
    { id: "05", name: "Coahuila" },
    { id: "14", name: "Querétaro" }
  ];

  regionesDummy: FeatureCollection<Polygon | MultiPolygon> = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "id": "29",  
        "properties": {
          "nombre": "Yucatán",
          "clave": "31"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-90.482, 20.476],
              [-90.482, 21.847],
              [-88.693, 21.847],
              [-88.693, 20.476],
              [-90.482, 20.476]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "id": "9",
        "properties": {
          "nombre": "Ciudad de México",
          "clave": "09"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-99.405, 19.029],
              [-99.405, 19.480],
              [-98.950, 19.480],
              [-98.950, 19.029],
              [-99.405, 19.029]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "id": "14",
        "properties": {
          "nombre": "Jalisco",
          "clave": "14"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-104.496, 20.000],
              [-104.496, 21.833],
              [-102.000, 21.833],
              [-102.000, 20.000],
              [-104.496, 20.000]
            ]
          ]
        }
      }
    ]
  };


  subscription_GetFeaturesSelected: Subscription;
  constructor(changeDetectorRef: ChangeDetectorRef, 
    media: MediaMatcher,
    private mapHelperService: MapHelperService, 
    private panelAddService: PanelAddGeofencesService,
    private http: HttpClient,
    private turfHelperService: TurfHelperService,){
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.panelAddService.selectedFeatures.features = [];
    this.selectedZoneId = 1;
  }

  ngAfterViewInit(): void {
    this.startSelector();
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    this.startedMunicipiosSelection = false;
    this.stopSelector();
    // Limpiar las features seleccionadas al salir del componente
    this.panelAddService.selectedFeatures.features = [];
    this.mapHelperService.featuresInsideArea.next(null);
  }

  onSelectionChange(event: PolygonSelectionEvent): void {
    this.panelAddService.selectedFeatures.features = event.selectedFeatures.features;
    if(!environment.production) console.log("selected features del map", this.panelAddService.selectedFeatures);

    if(this.panelAddService.selectedFeatures.features.length == 1 || this.selectedFeaturesStateBackUp.features.length == 1){
      if (!this.isReturningToState) {
        this.canSelectMunicipios = true;
      }
      var points = this.mapHelperService._map.getSource("pointsSource")._data;
      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, this.panelAddService.selectedFeatures.features[0]);
      if(!environment.production) console.log("points inside area", turfFeaturesInsideArea);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
      this.mapHelperService.featuresInsideArea.next(featuresResult);
    }else{
      if (!this.isReturningToState) {
        this.canSelectMunicipios = false;
      }
    }
  }

  async startSelector(){
    console.log("geofenceeee no activado", this.polygonSelector);
    if (!this.polygonSelector)
      return;

    await this.polygonSelector.activate();
    console.log("geofenceeee activado");
    if (this.isDestroyed) 
      return;

    switch (this.selectedZoneId) {
      case EnumGeofenceZones.Estados:
        const path = 'assets/mexico_geoJsons/estados/mexico.geojson';
        try {
          const geo = await this.getGeoJsonFromAssets(path);
          if (this.isDestroyed) 
            return;
          this.polygonSelector.loadGeoJson(geo);
          this.mapHelperService.FitBounds(geo);
        } catch (e) {
          console.error('Error cargando geoJson de  assets', e);
        }
        break;
      // case EnumGeofenceZones.Municipios:
      //   this.onStateSelectionChange();
      //   break;
      case EnumGeofenceZones.Regiones:
        this.polygonSelector.loadGeoJson(this.regionesDummy);
        this.mapHelperService.FitBounds(this.regionesDummy);
        break;
      default:
        break;
    }
  }

  stopSelector(){
    if (!this.polygonSelector) return;
    this.polygonSelector.deactivate();
    this.polygonSelector.clearGeoJson();
  }

  onZoneSelectionChange(event) {
    this.selectedZoneId = event.value;
    this.stopSelector();
    this.startSelector();
  }

  
  async toggleMunicipiosSelection(){
    if (!this.polygonSelector) return;

    if (!this.startedMunicipiosSelection) {
      this.startedMunicipiosSelection = true;

      this.selectedFeaturesStateBackUp.features = this.panelAddService.selectedFeatures.features;

      this.selectedStateId = this.panelAddService.selectedFeatures.features.length > 0 ? this.panelAddService.selectedFeatures.features[0].properties['CVE_ENT'] : "09";

      this.polygonSelector.deselectAll();

      const stateName = this.selectedFeaturesStateBackUp.features.length > 0 ? this.selectedFeaturesStateBackUp.features[0].properties['NOM_ENT'] : "México";
      if(!environment.production) console.log("seleccionado estado", this.selectedFeaturesStateBackUp.features, stateName);
      
      const path = 'assets/mexico_geoJsons/municipios/'+ stateName +'.json';
      try {
        const geo = await this.getGeoJsonFromAssets(path);
        if (this.isDestroyed) 
          return;
        this.polygonSelector.loadGeoJson(geo);
        this.mapHelperService.FitBounds(geo);
      } catch (e) {
        console.error('Error cargando geoJson de  assets', e);
      }

      // setTimeout(() => {
      //   this.polygonSelector.selectAll();
      // }, 500);
    }else{
      this.startedMunicipiosSelection = false;
      this.canSelectMunicipios = false;
      this.isReturningToState = true;
      // setTimeout(() => {
      //   if(this.panelAddService.selectedFeatures.features.length == 1 || this.selectedFeaturesStateBackUp.features.length == 1)
      //     this.canSelectMunicipios = true;
      // }, 5000);
      this.polygonSelector.deselectAll();
      this.polygonSelector.clearGeoJson();
      const path = 'assets/mexico_geoJsons/estados/mexico.geojson';
      try {
        const geo = await this.getGeoJsonFromAssets(path);
        if (this.isDestroyed) 
          return;
        this.polygonSelector.loadGeoJson(geo);
        this.mapHelperService.FitBounds(geo);
      } catch (e) {
        console.error('Error cargando geoJson de  assets', e);
      }
      if(!environment.production) console.log("restoring state selection", this.selectedFeaturesStateBackUp);

      setTimeout(() => {
        if (this.isDestroyed) 
          return;
        this.polygonSelector.selectByProperty("CVE_ENT", this.selectedFeaturesStateBackUp.features[0].properties['CVE_ENT']);
        this.selectedFeaturesStateBackUp.features = [];
      }, 500);

      setTimeout(() => {
        if (this.isDestroyed) 
          return;
        this.isReturningToState = false;
        this.canSelectMunicipios = true;
      }, 1000);
      
    }
    
  }

  async getGeoJsonFromAssets(path: string): Promise<GeoJSON.FeatureCollection<Polygon | MultiPolygon>> {
    const geo = await firstValueFrom(this.http.get(path)) as GeoJSON.FeatureCollection<Polygon | MultiPolygon>;
    geo.features.forEach((feature, index) => {
      if (feature.id == undefined || feature.id == null) 
        feature.id = index + 1;
    });
    return geo;
  }
}
